export function openContact(contact, type) {
  if (!contact) return
  switch (type) {
    case "facebook":
      return window.open(contact)
    case "line":
      return window.open('https://line.me/R/oaMessage/' + contact)
    case "tel":
      return window.open('tel:' + contact, '_parent')
    default:
      return window.open(contact);
  }
}

export function toTelephoneNumber(phone) {
  const cleaned = (String(phone)).replace(/\D/g, '');
  switch (cleaned.length) {
    case 9:
      return cleaned.substring(0, 2) + '-' + cleaned.substring(2, 5) + '-' + cleaned.substring(5, cleaned.length)
    case 10:
      return cleaned.substring(0, 3) + '-' + cleaned.substring(3, 6) + '-' + cleaned.substring(6, cleaned.length)
    default:
      return cleaned
  }
}

export default { openContact, toTelephoneNumber }


// WEBPACK FOOTER //
// ./src/utils/contact.js